import { combineReducers } from 'redux';
import bizGlobalReducers from './global';

const rootReducer = combineReducers({
  bizGlobalReducers,

});

export default rootReducer;
